import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { ExerciseSeriesInfo, ExerciseSeriesType } from '../../../../config/api/models/Exercise';
import SeriesCard from './SeriesCard';
import { StyledGrid, StyledWrapper } from './Atoms';

type Props = {
  type: ExerciseSeriesType;
  data: ExerciseSeriesInfo[];
  onDeleteSeries: () => void;
  onPatchSeries: () => void;
  isTrajectoryViewEditMode?: boolean;
};

const SeriesList: FC<Props> = ({
  data,
  onDeleteSeries,
  onPatchSeries,
  isTrajectoryViewEditMode = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {data.length > 0 && (
        <StyledWrapper>
          <Typography variant="h3">{t('trajectory.sections.shared.series')}</Typography>
          <StyledGrid container spacing={2}>
            {data.map((series, index) => (
              <Grid key={index} item xs={4}>
                <SeriesCard
                  data={series}
                  onDeleteSeries={onDeleteSeries}
                  onPatchSeries={onPatchSeries}
                  isTrajectoryViewEditMode={isTrajectoryViewEditMode}
                />
              </Grid>
            ))}
          </StyledGrid>
        </StyledWrapper>
      )}
    </>
  );
};

export default SeriesList;
